import { render, staticRenderFns } from "./RatesView.vue?vue&type=template&id=c6f37f72&scoped=true"
import script from "./RatesView.vue?vue&type=script&lang=js"
export * from "./RatesView.vue?vue&type=script&lang=js"
import style0 from "./RatesView.vue?vue&type=style&index=0&id=c6f37f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f37f72",
  null
  
)

export default component.exports